var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

export default {
    /**
     * Marks form and immediate child forms submitted
     *
     * @param {Object} form
     */
    markFormsSubmitted: function markFormsSubmitted(form) {
        form.submitted = true;

        Object.keys(form).forEach(function (key) {
            if (_typeof(form[key]) === 'object' && form[key].$submitted !== undefined // checking if child is a form
            ) {
                    form[key].submitted = true;
                }
        });
    }
};


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/modelvalidation/FormUtil.js
// module id = 316
// module chunks = 0